var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layout-gestao", {}, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c(
          "form",
          {
            attrs: {
              autocomplete: "off",
              method: "post",
              disabled: _vm.isLoading,
              "data-vv-scope": "form",
            },
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.onBeforeSaveItem.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "row mb-3" }, [
              _c("div", { staticClass: "col-sm-auto" }, [
                _c("h1", { staticClass: "content-title" }, [
                  _vm._v(_vm._s(_vm.titleItem)),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "MaterialInput",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|max:250",
                            expression: "'required|max:250'",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          readonly: _vm.readonlyFormItem,
                          type: "text",
                          id: "input-description",
                          name: "description",
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError(`description`) },
                          ],
                          error: _vm.fnFirstError(`description`),
                          helpText: _vm.texts.description.help,
                        },
                        model: {
                          value: _vm.form.description,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "description",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.description",
                        },
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.texts.description.label) +
                            "\n                            "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("buttons-footer", {
              attrs: {
                enableButtons: !_vm.readonlyFormItem,
                cancelTitle: _vm.cancelTitle,
                submitTitle: _vm.submitTitle,
                isDisabled: _vm.isDisabled,
              },
              on: {
                save: _vm.onBeforeSaveItem,
                cancel: function ($event) {
                  return _vm.handleBack(
                    _vm.moduleInternalCode + ".municipal_works_type",
                    true
                  )
                },
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }